import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const dashBoardConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/dashboard",
    component: React.lazy(() => import("./dashboard")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/payment-gateways",
    component: React.lazy(() => import("./gateways")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/transaction-history",
    component: React.lazy(() => import("./transactionhistory")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/client-management",
    component: React.lazy(() => import("./clientManagement")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/error-logs",
    component: React.lazy(() => import("./ErrorLogs")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/config-charges",
    component: React.lazy(() => import("./configCharges")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/config-user-charges",
    component: React.lazy(() => import("./configUserCharges")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/add-plan",
    component: React.lazy(() => import("./addplan")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/plan-list",
    component: React.lazy(() => import("./planlist")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/payment-gateways/stripe-list",
    component: React.lazy(() => import("./stripelist")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/client-management/config-user-charges",
    component: React.lazy(() => import("./configUserCharges")),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/client-management/config-user-gateway",
    component: React.lazy(() => import("./configGateway")),
  },
];
